export default "__VITE_ASSET__B5ZkH4he__"